'use strict';

var GridGridControlTypeDropdownController = function GridGridControlTypeDropdownController($scope) {
  $scope.$watch('controlType', function (newVal, oldVal) {
    if (newVal !== oldVal) {
      $scope.updateInventoryControls(newVal);
    }
  });
};
GridGridControlTypeDropdownController.$inject = ['$scope'];
module.exports = GridGridControlTypeDropdownController;